var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4601 5.15022H3.34674C3.5204 5.15022 3.66118 5.00944 3.66118 4.83578C3.66118 4.66212 3.5204 4.52134 3.34674 4.52134H1.14565C0.971994 4.52134 0.831213 4.66212 0.831213 4.83578V7.66575C0.831213 7.83941 0.971994 7.98019 1.14565 7.98019C1.31932 7.98019 1.4601 7.83941 1.4601 7.66575V5.15022Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3778 7.35131H0.516773C0.343112 7.35131 0.202332 7.49209 0.202332 7.66575C0.202332 7.83941 0.343112 7.98019 0.516773 7.98019H8.3778C8.55146 7.98019 8.69224 7.83941 8.69224 7.66575C8.69224 7.49209 8.55146 7.35131 8.3778 7.35131Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66118 3.26357H5.54783C5.72149 3.26357 5.86227 3.12279 5.86227 2.94913C5.86227 2.77547 5.72149 2.63469 5.54783 2.63469H3.34674C3.17308 2.63469 3.0323 2.77547 3.0323 2.94913V7.66575C3.0323 7.83941 3.17308 7.98019 3.34674 7.98019C3.5204 7.98019 3.66118 7.83941 3.66118 7.66575V3.26357Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23339 7.66575V1.06249C5.23339 0.888827 5.37417 0.748047 5.54783 0.748047H7.74891C7.92258 0.748047 8.06336 0.888827 8.06336 1.06249V7.66575C8.06336 7.83941 7.92258 7.98019 7.74891 7.98019H5.54783C5.37417 7.98019 5.23339 7.83941 5.23339 7.66575ZM7.43447 7.35131H5.86227V1.37693H7.43447V7.35131Z",
    fill: "#1C1C1C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBar);
export default __webpack_public_path__ + "static/media/ChartBar.7f7b564d2a96c506d03a8c0864717a6c.svg";
export { ForwardRef as ReactComponent };